import { ORDERBY } from '../actions';

function getOtherOrder( order ) {
	return 'asc' === order ? 'desc' : 'asc';
}

export default ( state = { orderby: 'participant', order: 'asc' }, action ) => {
	switch ( action.type ) {
		case ORDERBY:
			if ( action.payload === state.orderby ) {
				return {
					orderby: state.orderby,
					order  : getOtherOrder( state.order )
				};
			} else {
				return { orderby: action.payload, order: state.order };
			}
	}
	return state;
}